import React from "react";
import { MdCheckCircle } from "react-icons/md";

const Guarantee = ({ handleScheduleClick }) => {
  return (
    <div className="with-navbar-offset">
      <div className="top-bar-wrapper enhanced-top-bar">
        <div className="container">
          <div className="row">
            <div className="col-12 top-bar-info-main enhanced-top-bar-info">
              <span className="lincensed-para enhanced-top-bar-text">
                ⭐ Not a licensed contractor
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="guarantee-hero">
        <div className="guarantee-hero-content">
          <h1 className="guarantee-hero-title">
            Our Guarantee:{" "}
            <span className="highlight">Respect. Reliability. Results.</span>
          </h1>
          <div className="guarantee-hero-text">
            <h2>We Know Why You're Here.</h2>
            <p>
              You've been ghosted, overcharged, or left with a half-finished job
              before. We were too — that's why we built Breakthrough Handyman.
            </p>
            <p>
              Our guarantee isn't just about workmanship. It's about treating
              you, your time, and your home with the respect you deserve. Here's
              what you can count on:
            </p>
          </div>
        </div>
        <div className="guarantee-hero-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
          <div className="decoration-circle circle-3"></div>
        </div>
      </section>

      {/* Guarantee Feature Section */}
      <section className="guarantee-feature-section">
        <div className="guarantee-feature-stack">
          <div className="guarantee-feature-card" data-step="1">
            <span className="guarantee-feature-icon">
              <MdCheckCircle color="#ffcf14" size={32} />
            </span>
            <div className="guarantee-feature-content">
              <h3 className="guarantee-feature-title">
                Real Appointment Times — Not Vague Windows
              </h3>
              <p className="guarantee-feature-desc">
                When we say <strong>9:00am</strong>, we mean it. If your
                handyman is running behind, they'll call you directly — so
                you're never stuck wondering or waiting around all day.
              </p>
            </div>
          </div>
          <div className="guarantee-feature-card" data-step="2">
            <span className="guarantee-feature-icon">
              <MdCheckCircle color="#ffcf14" size={32} />
            </span>
            <div className="guarantee-feature-content">
              <h3 className="guarantee-feature-title">
                Full Transparency on Price and Time
              </h3>
              <p className="guarantee-feature-desc">
                You'll get an honest estimate of time and cost before the job
                starts — based on over 12,500 appointments.
                <br />
                <br />
                If it takes less time, you pay less.
                <br />
                <br />
                If it looks like it'll take longer, your handyman will walk you
                through the "why" and give you options before moving forward.
              </p>
            </div>
          </div>
          <div className="guarantee-feature-card" data-step="3">
            <span className="guarantee-feature-icon">
              <MdCheckCircle color="#ffcf14" size={32} />
            </span>
            <div className="guarantee-feature-content">
              <h3 className="guarantee-feature-title">
                You Don't Pay Until the Job Is Done — And You're Happy
              </h3>
              <p className="guarantee-feature-desc">
                No deposits. No pre-payments. Your handyman takes payment only
                after you've reviewed the work and given it the green light.
                <br />
                <br />
                <em>"If you're not satisfied, we're not done."</em>
              </p>
            </div>
          </div>
          <div className="guarantee-feature-card" data-step="4">
            <span className="guarantee-feature-icon">
              <MdCheckCircle color="#ffcf14" size={32} />
            </span>
            <div className="guarantee-feature-content">
              <h3 className="guarantee-feature-title">
                No Markups on Materials — Ever
              </h3>
              <p className="guarantee-feature-desc">
                We don't sell you parts. We don't mark up trips to the store.
                You pay for the job, not for someone to make money off your
                materials.
              </p>
            </div>
          </div>
          <div className="guarantee-feature-card" data-step="5">
            <span className="guarantee-feature-icon">
              <MdCheckCircle color="#ffcf14" size={32} />
            </span>
            <div className="guarantee-feature-content">
              <h3 className="guarantee-feature-title">
                Local, Professional Handymen Who Take Their Work Seriously
              </h3>
              <p className="guarantee-feature-desc">
                Our handymen are full-time, not side hustlers. They support
                families. They take pride in their work. And they're accountable
                — to us and to you.
                <br />
                <br />
                Each one warranties their work. They're not contractors. They're
                your handyman for the appointment. And they know your
                satisfaction is what gets them rebooked.
              </p>
            </div>
          </div>
          <div className="guarantee-feature-card" data-step="6">
            <span className="guarantee-feature-icon">
              <MdCheckCircle color="#ffcf14" size={32} />
            </span>
            <div className="guarantee-feature-content">
              <h3 className="guarantee-feature-title">
                Same-Day or Next-Day Availability — Most of the Time
              </h3>
              <p className="guarantee-feature-desc">
                We don't just talk about being responsive — we actually show up.
                Most jobs can be scheduled within 24 hours or less.
              </p>
            </div>
          </div>
          <div className="guarantee-feature-card" data-step="7">
            <span className="guarantee-feature-icon">
              <MdCheckCircle color="#ffcf14" size={32} />
            </span>
            <div className="guarantee-feature-content">
              <h3 className="guarantee-feature-title">
                We Handle Issues. We Don't Disappear.
              </h3>
              <p className="guarantee-feature-desc">
                We can't guarantee perfection, but we can guarantee this:
                <br />
                <br />
                If something goes wrong, we will make it right.
                <br />
                <br />
                If a job needs adjustment, we'll address it fast.
                <br />
                <br />
                We don't ghost, hide, or argue. We fix it. Period.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Policies Info Section */}
      <section className="guarantee-policies-info">
        <div className="policies-info-icon" role="img" aria-label="warning">
          ⚠️
        </div>
        <div className="policies-info-content">
          <h3 className="policies-info-title">
            Our Policies Exist to Protect Everyone
          </h3>
          <p className="policies-info-desc">
            We enforce cancellation fees and late arrival fees not to be harsh —
            but to keep things running for everyone. Your handyman has 2–3 jobs
            a day. When one job runs late or cancels last minute, it affects
            every other customer on the schedule.
          </p>
          <div className="policies-info-list">
            <span>These policies protect:</span>
            <ul>
              <li>Your appointment time</li>
              <li>Our handymen's income</li>
              <li>The flow that allows us to show up on time for everyone</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Bottom Line Banner Section */}
      <section className="guarantee-bottom-banner">
        <div className="bottom-banner-content">
          <div className="bottom-banner-main">
            We're not trying to be the{" "}
            <span className="bottom-banner-em">cheapest</span>.<br />
            We're trying to be the{" "}
            <span className="bottom-banner-em">most reliable</span>.<br />
            <span className="bottom-banner-guarantee">
              And that's what we guarantee.
            </span>
          </div>
          <div className="bottom-banner-cta-group">
            <button
              className="bottom-banner-cta chat"
              onClick={handleScheduleClick}
            >
              💬 Want to see if we're the right fit? Ask Alex now.
            </button>
            <a className="bottom-banner-cta call" href="tel:+6029385415">
              📞 Call Now — 602-938-5415
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Guarantee;
